// extracted by css-extract-rspack-plugin
export default {"cls1":"Accordion-cls1_14d","cls2":"Accordion-cls2_qFQ Accordion-cls1_14d"};